import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import {
  columnCollectionDatasetCount,
  columnCollectionDatasetLastAdded,
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnTools,
} from '@/constants/fields';
import { presentationOptions } from '@/constants/states';
import paging, { onCategoryScroll } from '@/hooks/paging';
import CardsHeader from '@/components/cards/CardsHeader';
import CollectionsTable from '../components/CollectionsTable';
import CollectionsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CollectionsPanelContainer';
import CollectionCards from '../components/CollectionCards';
import CollectionsFilters from './CollectionsFilters';

const buildColumns = (allowMultiSelect) => {
  const columns = [
    columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnTools,
    columnCollectionDatasetLastAdded,
    columnCollectionDatasetCount,
  ];
  if (allowMultiSelect) {
    columns.push(columnMultiSelect);
  }
  return columns;
};

const CollectionsPanelFull = ({
  allowMultiSelect,
  allowStatus,
  canCreate,
  canRead,
  category,
  currentPage,
  collections,
  display,
  fetchData,
  newCollectionCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  togglePresentation,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);
  return (
    <CollectionsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-collections-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <CollectionsFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <CollectionCards
          canCreate={canCreate}
          category={category}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={collections}
          newCollectionCode={newCollectionCode}
          onCheckBoxClick={allowMultiSelect ? (value) => onCheckBoxClick(category, value) : undefined}
          readErrors={readErrors}
          readStatus={readStatus}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <CollectionsTable
        canCreate={canCreate}
        category={category}
        collections={collections}
        columns={buildColumns(allowMultiSelect, allowStatus)}
        currentPage={currentPage}
        fetchData={fetchData}
        onCheckBoxClick={allowMultiSelect ? (value) => onCheckBoxClick(category, value) : undefined}
        newCollectionCode={newCollectionCode}
        pageCount={pageCount}
        pageSize={pageSize}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
      )}
    </CollectionsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsPanelFull);
